export default __webpack_public_path__ + "static/media/Ellipse162.cf191e50.svg";